import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container mx-auto pt-8 pb-16 px-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-gray-100 text-3xl font-semibold pt-2" }, "My Report", -1)
const _hoisted_3 = { class: "bg-white text-gray-700 p-4 mt-8 rounded-md shadow-md" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "mb-4 flex justify-between flex-col md:flex-row" }
const _hoisted_8 = { class: "flex flex-col sm:flex-row mb-2 md:mb-0" }
const _hoisted_9 = { class: "flex flex-1 rounded-md mb-2 sm:mb-0 mr-0 sm:mr-2 md:mr-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, " Month ", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "flex flex-1 rounded-md mb-2 sm:mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-200 bg-gray-50 text-gray-500 text-sm" }, " Contract ", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "flex justify-between items-stretch" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Import", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", null, "Export", -1)
const _hoisted_19 = { class: "flex mt-4 justify-end" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "Save report", -1)
const _hoisted_21 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_23 = { class: "inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-11/12 max-w-lg sm:mx-4" }
const _hoisted_24 = { class: "bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Import CSV Report", -1)
const _hoisted_26 = { class: "inline-block mt-4 w-auto text-sm font-semibold py-1 px-2 uppercase rounded-md text-indigo-600 bg-indigo-100" }
const _hoisted_27 = { class: "m-auto" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Select or drop .csv file", -1)
const _hoisted_29 = {
  key: 0,
  class: "mt-4 w-auto text-sm font-semibold"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "py-1 px-2 rounded-l-md text-gray-600 bg-gray-100 border border-gray-200 border-r-0" }, "Selected file:", -1)
const _hoisted_31 = { class: "py-1 px-2 rounded-r-md text-indigo-600 bg-indigo-100 border border-indigo-200" }
const _hoisted_32 = { class: "bg-gray-50 px-4 py-3 sm:px-6 sm:flex flex-row-reverse" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "Import", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadIcon = _resolveComponent("UploadIcon")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_TruckIcon = _resolveComponent("TruckIcon")!
  const _component_report_table = _resolveComponent("report-table")!
  const _component_CheckIcon = _resolveComponent("CheckIcon")!
  const _component_DialogOverlay = _resolveComponent("DialogOverlay")!
  const _component_TransitionChild = _resolveComponent("TransitionChild")!
  const _component_DialogTitle = _resolveComponent("DialogTitle")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_TransitionRoot = _resolveComponent("TransitionRoot")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Loading. "))
        : (_ctx.contracts.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, " No contracts to show. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event)),
                      class: "form-select appearance-none block w-full md:w-auto text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200 rounded-r-md"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: month.key,
                          value: month
                        }, _toDisplayString(month.name), 9, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedMonth]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedContract) = $event)),
                      class: "form-select appearance-none block w-full md:w-auto text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-200 rounded-r-md"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contracts, (contract) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: contract.id,
                          value: contract
                        }, [
                          _createTextVNode(_toDisplayString(contract.contractType.id.toUpperCase()), 1),
                          (contract.measureUnit)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " (" + _toDisplayString(contract.measureUnit.id) + _toDisplayString(contract.measureUnitLabel ? `: ${contract.measureUnitLabel}` : '') + ")", 1))
                            : _createCommentVNode("", true)
                        ], 8, _hoisted_14))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedContract]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_app_button, {
                    onClick: _ctx.openImportModal,
                    type: "blue",
                    class: "mr-1 flex-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                      _hoisted_17
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_app_button, {
                    onClick: _ctx.exportToCsv,
                    type: "blue",
                    class: "ml-1 flex-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TruckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                      _hoisted_18
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              (_openBlock(), _createBlock(_component_report_table, {
                ref: "reportTable",
                key: _ctx.selectedContract.id + '-' + _ctx.selectedMonth.key + '-' + _ctx.reportTableRefreshKey,
                dataMode: "month",
                contract: _ctx.selectedContract,
                month: _ctx.selectedMonth
              }, null, 8, ["contract", "month"])),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_app_button, {
                  onClick: _ctx.onReportSubmit,
                  type: "blue",
                  class: _normalizeClass(['w-full sm:w-auto'])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CheckIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                    _hoisted_20
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
    ]),
    _createVNode(_component_TransitionRoot, {
      as: "template",
      show: _ctx.modalIsOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Dialog, {
          as: "div",
          class: "fixed z-10 inset-0 overflow-y-auto",
          onClose: _ctx.closeImportModal
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DialogOverlay, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              _hoisted_22,
              _createVNode(_component_TransitionChild, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_DialogTitle, {
                        as: "h2",
                        class: "text-3xl leading-6 font-semibold text-gray-800 mb-4 tracking-wide"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, _toDisplayString(this.selectedMonth.name), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_file_upload, {
                        onInputFile: _ctx.onInputFile,
                        drop: true,
                        extensions: "csv",
                        multiple: false,
                        class: "w-full m-auto py-8 bg-gray-50 rounded-md border border-gray-100"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_app_button, {
                              onClick: _ctx.importCsvFile,
                              type: "green"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_PlusIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                                _hoisted_28
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          (_ctx.csvImportFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _hoisted_30,
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.csvImportFile.name), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["onInputFile"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_app_button, {
                        onClick: _ctx.importCsvFile,
                        type: "blue",
                        class: _normalizeClass(['mb-2 sm:mb-0 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UploadIcon, { class: "h-5 w-5 mr-2 -ml-1" }),
                          _hoisted_33
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_app_button, {
                        onClick: _ctx.closeImportModal,
                        type: "gray",
                        class: _normalizeClass(['mr-2 w-full sm:w-auto'])
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}